import { render, staticRenderFns } from "./language-panel.vue?vue&type=template&id=4db85430&"
import script from "./language-panel.vue?vue&type=script&lang=js&"
export * from "./language-panel.vue?vue&type=script&lang=js&"
import style0 from "./language-panel.vue?vue&type=style&index=0&id=4db85430&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports